import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Feedback } from '../../../models/Feedback';
import { loadFeedback } from '../../../state/feedback/feedback.actions';
import { selectAllFeedback } from '../../../state/feedback/feedback.selector';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { PageHeaderComponent } from '../../page-header/page-header.component';

@Component({
  selector: 'app-feedback-overview',
  standalone: true,
  templateUrl: './feedback-overview.component.html',
  styleUrl: './feedback-overview.component.css',
  imports: [CommonModule, MatTableModule, MatIconModule, MatButtonModule, PageHeaderComponent],
})
export class FeedbackOverviewComponent implements OnInit {
  feedback$: Observable<Feedback[]>;
  displayedColumns: string[] = ['customer', 'text', 'rating'];

  constructor(private store: Store) {
    this.feedback$ = this.store.select(selectAllFeedback);
  }

  ngOnInit(): void {
    this.store.dispatch(loadFeedback());
  }

  getCustomerName(feedback: Feedback): string {
    return feedback.customer?.userDetails
      ? `${feedback.customer.userDetails.firstName} ${feedback.customer.userDetails.lastName}`
      : '';
  }

  getStars(rating: number): number[] {
    return Array(5).fill(0).map((_, i) => i < rating ? 1 : 0);
  }

  getRatingColor(rating: number | undefined): string {
    if (typeof rating !== 'number') return '';
    if (rating <= 1) return 'low';
    if (rating <= 3) return 'medium';
    return 'high';
  }

  back(): void {
    window.history.back();
  }
}
